// 服务商工作台
export default [
	{
		path: '/provider',
		name: 'Provider',
		redirect: '/provider/profile',
		component: () => import('@/views/provider/index'),
		meta: { title: '服务商工作台' },
		children: [
			{
				path: 'profile',
				name: 'ProviderProfile',
				component: () => import('@/views/provider/profile'),
				meta: { title: '个人资料' }
			},
			{
				path: 'application',
				name: 'ProviderApplication',
				component: () => import('@/views/provider/application'),
				meta: { title: '商家申请' }
			},
			{
				path: 'store',
				name: 'ProviderStore',
				component: () => import('@/views/provider/store'),
				meta: { title: '我的店铺', requiresApprovedShop: true }
			},
			{
				path: 'store/close',
				name: 'ProviderStoreClose',
				component: () => import('@/views/provider/storeClose'),
				meta: { title: '闭店申请', requiresApprovedShop: true }
			},
			{
				path: 'store/change',
				name: 'ProviderStoreChange',
				component: () => import('@/views/provider/storeChange'),
				meta: { title: '店铺信息变更', requiresApprovedShop: true }
			},
			{
				path: 'store/restart',
				name: 'ProviderStoreRestart',
				component: () => import('@/views/provider/storeChange'),
				meta: { title: '重启店铺', requiresApprovedShop: true }
			},
			{
				path: 'product-publish',
				name: 'ProviderProductPublish',
				component: () => import('@/views/provider/productPublish'),
				meta: { title: '发布商品', requiresApprovedShop: true }
			},
			{
				path: 'products',
				name: 'ProviderProducts',
				component: () => import('@/views/provider/products'),
				meta: { title: '商品管理', requiresApprovedShop: true }
			},
			{
				path: 'orders',
				name: 'ProviderOrders',
				component: () => import('@/views/provider/orders'),
				meta: { title: '订单管理', requiresApprovedShop: true }
			},
			{
				path: 'configuration',
				name: 'ProviderConfiguration',
				component: () => import('@/views/provider/configuration'),
				meta: { title: '配置管理', requiresApprovedShop: true }
			},
			{
				path: 'configuration/edit',
				name: 'ProviderConfigurationEdit',
				component: () => import('@/views/provider/configuration/edit'),
				meta: { title: '商品权益配置', requiresApprovedShop: true }
			}
		]
	}
]
